<div class="prefixCot formulario-cotiza">
  <div>
  <!-- Vista Desktop -->
  <div class="hidden-xs">
    <div class="divResultadoDesk col-md-12 col-sm-12 col-lg-12">
      <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style="margin-top: 10px; margin-bottom: 10px;">
        Para recibir mensualmente el <span class="requiredIn">{{ cotizacion.values.porSueldo }}%</span> de tu ingreso 
        (<span class="requiredIn">${{ formatCurrency((+cotizacion.values.ingreso * cotizacion.values.porSueldo) / 100) }}</span>) 
        a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años, es necesario que ahorres desde hoy el 
        <span class="requiredIn">{{ cotizacion.aportaciones.porcentaje }}%</span> de éste 
        (<span class="requiredIn">${{ formatCurrency(cotizacion.aportaciones.mensual) }}</span>).
      </div>
    </div>

    <div class="divResultadoDesk col-md-12 col-sm-12 col-lg-12">
      <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style="margin-top: 10px;">
        Ahorrar con <span class="requiredIn">GNP Seguros</span> te brinda múltiples beneficios:
      </div>
      <br/><br/>
      <div class="col-md-4 col-sm-4 col-lg-4">
        <div class="col-md-10 col-sm-10 col-lg-10" id="otro" style="background: white; min-height: 100px;">
          <ul><li>Garantizar por contrato el monto que recibirás.</li></ul>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-lg-4">
        <div class="col-md-10 col-sm-10 col-lg-10" id="otro" style="background: white; min-height: 100px;">
          <ul><li>Obtener beneficios Fiscales mientras ahorras.</li></ul>
        </div>
      </div>
      <div class="col-md-4 col-sm-4 col-lg-4">
        <div class="col-md-10 col-sm-10 col-lg-10" id="otro" style="background: white; min-height: 100px; margin-bottom: 10px;">
          <ul><li>Ajuste automático por inflación. ¡El monto que recibirás nunca pierde valor con el paso del tiempo!</li></ul>
        </div>
      </div>
    </div>

    <div class="divResultadoDesk col-md-12 col-sm-12 col-lg-12">
      <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style="margin-top: 10px; margin-bottom: 10px;">
        Y siempre encontrarás una opción a tu medida...
      </div>
      <p><br/></p>

      @if (ahorroMensualNumber > 0) {
        <div>
          <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style="margin-top: 10px; margin-bottom: 10px;">
            @if ((+cotizacion.values.edadretiro - +cotizacion.values.edad_actual) < 10) {
              <div>
                Ahorrando <span class="requiredIn">${{ formatCurrency(cotizacion.res?.nprima) }}</span> pesos mensuales de manera constante <span class="requiredIn">garantizas</span> un monto mensual de <span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.monto) }}</span> pesos durante <span class="requiredIn">{{ cotizacion.values.anios_pension }}</span> años a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años.
              </div>
            } @else {
              <div>
                Ahorrando <span class="requiredIn">${{ formatCurrency(cotizacion.res?.nprima) }}</span> pesos mensuales de manera constante garantizas un monto mensual de <span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.monto) }}</span> pesos durante <span class="requiredIn">{{ cotizacion.values.anios_pension }}</span> años a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años.
                <span>Además... Como un beneficio de <span class="requiredIn">GNP Seguros</span>, si llegaras a faltar, tus seres queridos recibirán el monto contemplado para tu Retiro (<span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.sumaAsegurada) }}</span> más la inflación acumulada).</span>
              </div>
            }
          </div>

          @if (reahorro()) {
            <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" style="margin-top: 10px; margin-bottom: 10px;">
              <div class="form-group">
                <label for="ahorro_mensualcot">Ahorrando <span class="requiredIn">*</span></label>
                <input type="text" maxlength="6" class="form-control browser-default" id="ahorro_mensualcot"
                       [value]="ahorroMensualCot()" (input)="onInputChange($any($event.target).value)" />
                @if (mensajeError()) {
                  <p class="errorMsj text-left">{{ mensajeError() }}</p>
                }
              </div>
            </div>
          }

          <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
            <button class="btn btn-gnp" (click)="regresar()">Regresar</button>&nbsp;&nbsp;
            @if (reahorro()) {
              <button class="btn btn-gnp" (click)="recotizar()">Recotizar</button>
            } @else {
              <button class="btn btn-gnp-modahorro" (click)="muestraAhorro()">Modificar ahorro mensual</button>
            }
          </div>
        </div>
      } @else {
        <div>
          <div class="col-md-5 col-sm-5 col-lg-5 etiquetaAzul">
            <label for="ahorro_mensualcot">¿Cuánto puedo ahorrar mensualmente para mi retiro? <span class="requiredIn">*</span></label>
          </div>
          <div class="col-md-4 col-sm-4 col-lg-4 etiquetaAzul">
            <div class="form-group">
              <input type="text" maxlength="6" class="form-control browser-default" id="ahorro_mensualcot"
                     [value]="ahorroMensualCot()" (input)="onInputChange($any($event.target).value)" />
              @if (mensajeError()) {
                <p class="errorMsj text-left">{{ mensajeError() }}</p>
              }
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-lg-12 text-center" style="margin-top: 10px; margin-bottom: 10px;">
            <button class="btn btn-gnp" (click)="cotizar()">Cotizar</button>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Vista Móvil -->
  <div class="formulario-cotiza contenidoFormulario hidden-md hidden-sm hidden-lg">
    <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
      Para recibir mensualmente el <span class="requiredIn">{{ cotizacion.values.porSueldo }}%</span> de tu ingreso 
      (<span class="requiredIn">${{ formatCurrency((+cotizacion.values.ingreso * cotizacion.values.porSueldo) / 100) }}</span>) 
      a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años, es necesario que ahorres desde hoy el 
      <span class="requiredIn">{{ cotizacion.aportaciones.porcentaje }}%</span> de éste 
      (<span class="requiredIn">${{ formatCurrency(cotizacion.aportaciones.mensual) }}</span>).
    </div>

    <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px;">
      Ahorrar con <span class="requiredIn">GNP Seguros</span> te brinda múltiples beneficios:
    </div>

    <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul" id="otro" style="margin-top: 10px;">
      <ul>
        <li>Garantizar por contrato el monto que recibirás.</li>
        <li>Obtener beneficios Fiscales mientras ahorras.</li>
        <li>Ajuste automático por inflación. ¡El monto que recibirás nunca pierde valor con el paso del tiempo!</li>
      </ul>
    </div>

    <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px;">
      Y siempre encontrarás una opción a tu medida...
    </div>

    @if (ahorroMensualNumber > 0) {
      <div>
        <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
          @if ((+cotizacion.values.edadretiro - +cotizacion.values.edad_actual) < 10) {
            <div>
              Ahorrando <span class="requiredIn">${{ formatCurrency(cotizacion.res?.nprima) }}</span> pesos mensuales de manera constante <span class="requiredIn">garantizas</span> un monto mensual de <span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.monto) }}</span> pesos durante <span class="requiredIn">{{ cotizacion.values.anios_pension }}</span> años a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años.
            </div>
          } @else {
            <div>
              Ahorrando <span class="requiredIn">${{ formatCurrency(cotizacion.res?.nprima) }}</span> pesos mensuales de manera constante garantizas un monto mensual de <span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.monto) }}</span> pesos durante <span class="requiredIn">{{ cotizacion.values.anios_pension }}</span> años a partir de los <span class="requiredIn">{{ cotizacion.values.edadretiro }}</span> años. 
              <span>Además... Como un beneficio de <span class="requiredIn">GNP Seguros</span>, si llegaras a faltar, tus seres queridos recibirán el monto contemplado para tu Retiro (<span class="requiredIn">${{ formatCurrency(cotizacion.opcionMedida?.sumaAsegurada) }}</span> más la inflación acumulada).</span>
            </div>
          }
        </div>

        @if (reahorro()) {
          <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
            <div class="form-group">
              <label for="ahorro_mensualcot">Ahorrando <span class="requiredIn">*</span></label>
              <input type="text" maxlength="6" class="form-control browser-default" id="ahorro_mensualcot"
                     [value]="ahorroMensualCot()" (input)="onInputChange($any($event.target).value)" />
              @if (mensajeError()) {
                <p class="errorMsj text-left">{{ mensajeError() }}</p>
              }
            </div>
          </div>
        }

        <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
          <button class="btn btn-gnp" (click)="regresar()">Regresar</button>&nbsp;
          @if (reahorro()) {
            <button class="btn btn-gnp" (click)="recotizar()">Recotizar</button>
          } @else {
            <button class="btn btn-gnp-modahorro" (click)="muestraAhorro()">Modificar ahorro mensual</button>
          }
        </div>
      </div>
    } @else {
      <div>
        <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
          <div class="form-group">
            <label for="ahorro_mensualcot">¿Cuánto puedo ahorrar mensualmente para mi retiro? <span class="requiredIn">*</span></label>
            <input type="text" maxlength="6" class="form-control browser-default" id="ahorro_mensualcot"
                   [value]="ahorroMensualCot()" (input)="onInputChange($any($event.target).value)" />
            @if (mensajeError()) {
              <p class="errorMsj text-left">{{ mensajeError() }}</p>
            }
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-lg-12 etiquetaAzul text-center" style="margin-top: 10px; margin-bottom: 10px;">
          <button class="btn btn-gnp" (click)="regresar()">Regresar</button>&nbsp;
          <button class="btn btn-gnp" (click)="cotizar()">Cotizar</button>
        </div>
      </div>
    }
  </div>
</div>
</div>

